import NetInfo, {
  NetInfoState,
  NetInfoStateType,
} from '@react-native-community/netinfo';
import { OfflineModeSimulator } from '../utils/offline-mode/offline-mode-simulator';

const fetch = async (): Promise<NetInfoState> => {
  const isOfflineModeSimulated =
    OfflineModeSimulator.getInstance().checkEnabled();

  if (isOfflineModeSimulated) {
    return {
      details: null,
      isConnected: false,
      isInternetReachable: false,
      type: NetInfoStateType.none,
    };
  }

  return NetInfo.fetch();
};

export * from '@react-native-community/netinfo';

export default {
  ...NetInfo,
  fetch,
};
